var ezdia;
(function (ezdia) {
    var TEMPLATES = ezdia.templates.compute;
    function rules(watch, elem, compute) {
        var ruleObj = compute.rules;
        var content = '';
        var len = this.length - 1;
        var re = null;
        var pattern = ruleObj || '[^\\w]';
        var modifiers = '';
        if (typeof pattern !== 'string') {
            pattern = ruleObj.pattern;
            modifiers = ruleObj.modifiers;
        }
        re = new RegExp(pattern, 'ig');
        $.each(watch, function each(i) {
            var space = '';
            var val = this.value;
            if (i < len) {
                space += ' ';
            }
            if (val) {
                content += val.trim() + space;
            }
        });
        if (content) {
            content = content.replace(re, modifiers).toLowerCase();
        }
        elem.val(content);
    }
    function computeTemplates(watch, elem, compute, template) {
        var context = {};
        var value = '';
        $.each(watch, function eachwatch() {
            context[this.name] = this.value;
        });
        value = template(context);
        elem.val(value);
    }
    function updatePaypalId(watch, element) {
        var $this = $(watch);
        var value = $this.val();
        $.ajax({
            type: 'POST',
            url: 'fetchPaypalID.htm',
            data: "email=" + value,
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    element.val(response.msg).attr('readonly', 'readonly');
                }
                else {
                    element.val('').removeAttr('readonly');
                }
            }
        });
    }
    function multiplication(watch, element) {
        var val = 1;
        $.each(watch, function eachwatch() {
            val *= +$(this).val();
        });
        element.val(val);
    }
    function getBoolean(watch, compute) {
        var e_1, _a;
        var conditions = compute.conditions;
        var isTrue = false;
        var len = watch.length;
        for (var i = 0; i < len; i += 1) {
            var elem = watch[i];
            var val = $(elem).val();
            var condition = conditions[elem.name];
            try {
                for (var condition_1 = (e_1 = void 0, __values(condition)), condition_1_1 = condition_1.next(); !condition_1_1.done; condition_1_1 = condition_1.next()) {
                    var _b = condition_1_1.value, operator = _b.operator, value = _b.value;
                    var isArray = Array.isArray(value);
                    switch (operator) {
                        case 'EQ':
                            isTrue = isArray ? value.includes(val) : val === value;
                            break;
                        case 'NE':
                            isTrue = isArray ? !value.includes(val) : val !== value;
                            break;
                        case 'GT':
                            isTrue = val > value;
                            break;
                        case 'GTEQ':
                            isTrue = val >= value;
                            break;
                        case 'LT':
                            isTrue = val < value;
                            break;
                        case 'LTEQ':
                            isTrue = val <= value;
                            break;
                        default:
                            break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (condition_1_1 && !condition_1_1.done && (_a = condition_1.return)) _a.call(condition_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return isTrue;
    }
    function hide(watch, element, compute) {
        var row = element.closest('[data-row="row"]');
        toggleView(watch, row, compute);
    }
    function show(watch, element, compute) {
        var row = element.closest('[data-row="row"]');
        toggleView(watch, row, compute, true);
    }
    function toggleView(watch, element, compute, isShow) {
        var isTrue = getBoolean(watch, compute);
        if (isTrue) {
            element[isShow ? 'show' : 'hide']();
        }
        else {
            element[!isShow ? 'show' : 'hide']();
        }
    }
    function hideColumn(watch, element, compute) {
        toggleColumnView(watch, element, compute);
    }
    function showColumn(watch, element, compute) {
        toggleColumnView(watch, element, compute, true);
    }
    function toggleColumnView(watch, element, compute, isShow) {
        var columns = compute.columns;
        var table = $("#ez-js-group-field-table-" + compute.name);
        $.each(columns, function (i, column) {
            var td = table.find("[data-column=\"" + column + "\"]");
            toggleView(watch, td, compute, isShow);
        });
    }
    function getAnswerFormatOptions(valueStr) {
        var returnVal = {};
        var value = $.ezdia.getJsonObject(valueStr);
        if (!value || !value.length) {
            return null;
        }
        $.each(value, function (i, obj) {
            returnVal[obj.value] = obj.value;
        });
        return returnVal;
    }
    function createAnswersOnRun(watch, elem) {
        var name = elem[0].name;
        var id = name + "__wrapper";
        elem.hide().removeAttr('name').after("<div id=\"" + id + "\"></div>");
        var wrapper = $("#" + id);
        var row = wrapper.closest('[data-row="row"]');
        elem.data('name', name);
        elem.data('wrapper', wrapper);
        elem.data('row', row);
        createAnswers(watch, elem);
    }
    function createAnswers(watch, elem) {
        var options = null;
        var wrapper = elem.data('wrapper');
        var row = elem.data('row');
        var name = elem.data('name');
        var col = {
            isCustomeUI: true,
            column: {
                editable: true,
                edittype: 'radio',
                config: {
                    options: {}
                },
                name: name
            },
            value: elem.val()
        };
        $.each(watch, function eachwatch() {
            if (this.name === 'type' && this.value) {
                col.column.edittype = this.value;
            }
            else if (this.name === 'config') {
                options = getAnswerFormatOptions(this.value);
                col.column.config.options = options;
            }
        });
        if (col.column.edittype === 'html') {
            wrapper.html('');
            row.hide();
        }
        else if (options) {
            wrapper.html($.ezdia.inputs.radioCheck(col));
            row.show();
        }
        else {
            row.hide();
        }
    }
    function sowName(watch, elem, compute) {
        var e_2, _a;
        var context = {};
        var reference = compute.reference;
        var valueArray = [];
        $.each(watch, function eachwatch() {
            context[this.name] = this.value || '';
        });
        try {
            for (var reference_1 = __values(reference), reference_1_1 = reference_1.next(); !reference_1_1.done; reference_1_1 = reference_1.next()) {
                var name_1 = reference_1_1.value;
                if (context[name_1]) {
                    valueArray.push(context[name_1]);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (reference_1_1 && !reference_1_1.done && (_a = reference_1.return)) _a.call(reference_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        // eslint-disable-next-line no-undef
        var value = valueArray.join('-') + "-" + moment().format('MM'
        // eslint-disable-next-line no-undef
        ) + moment().format('D') + moment().format('YYYY');
        elem.val(value).trigger('change', true);
    }
    function updatePoNumberRow(watch, elem, compute) {
        var parentName = compute.parentName;
        watch.off('change.ez.compute');
        $("[name=" + elem[0].id + "]").on('change', function change() {
            var oldValue = elem.data().label;
            var newValue = elem.val();
            var suggestions = getPONumberSuggestions(elem);
            var isNewPONum = isNewPONumber(suggestions, newValue);
            setTimeout(function () {
                if (oldValue !== newValue) {
                    var rowContent = null;
                    if (!isNewPONum) {
                        rowContent = getPoNumberRowContent(newValue);
                    }
                    updatePoNumberRowContent.call(elem, parentName, rowContent);
                }
            }, 0);
        });
    }
    function getPONumberSuggestions($input) {
        var retValue = [];
        try {
            var suggestions = $input.data().ttTypeahead.dropdown.datasets[0].suggestions;
            retValue = suggestions;
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
        }
        return retValue;
    }
    function isNewPONumber(suggestions, newValue) {
        var e_3, _a;
        var retValue = true;
        if (suggestions.length) {
            try {
                for (var suggestions_1 = __values(suggestions), suggestions_1_1 = suggestions_1.next(); !suggestions_1_1.done; suggestions_1_1 = suggestions_1.next()) {
                    var value = suggestions_1_1.value.value;
                    if (newValue === value) {
                        retValue = false;
                        break;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (suggestions_1_1 && !suggestions_1_1.done && (_a = suggestions_1.return)) _a.call(suggestions_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        return retValue;
    }
    function getPoNumberRowContent(id) {
        var returnVal;
        var orgName = $('[name=db_user]').val();
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: 'getPODetails.htm',
            data: { id: id, org_name: orgName },
            async: false,
            success: function (response) {
                returnVal = response.msg;
            }
        });
        return returnVal;
    }
    function updatePoNumberRowContent(parentName, rowContentArray) {
        var e_4, _a;
        var $tr = $(this).closest('tr');
        var index = $tr.index();
        var $input = $("[name=" + parentName + "]");
        var value = $input.val();
        var disbaleInputs = false;
        if (rowContentArray) {
            var rowContent = ezdia.util.jsonParse(rowContentArray);
            var jsonValue = ezdia.util.jsonParse(value) || [];
            var amount = rowContent[0].amount;
            disbaleInputs = true;
            try {
                for (var _b = __values(Object.entries(rowContent[0])), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                    if (key === 'ponumber') {
                        continue;
                    }
                    else if (key === 'amount') {
                        jsonValue[index][key] = v;
                    }
                    else {
                        jsonValue[index][key] = '';
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            $tr.find("[data-path=\"groupFields__amount\"]").val(amount);
            var stringValue = JSON.stringify(jsonValue);
            $input.val(stringValue).trigger('change');
        }
        setTimeout(function () {
            updatePoNumberRowsInputs($tr, disbaleInputs);
        }, 0);
    }
    function updatePoNumberRowsInputs($tr, disable) {
        var amountCssProps = {
            'pointer-events': 'none'
        };
        var cssProps = __assign(__assign({}, amountCssProps), { opacity: 0.2 });
        if (!disable) {
            amountCssProps = {
                'pointer-events': 'all'
            };
            cssProps = __assign(__assign({}, amountCssProps), { opacity: 1 });
        }
        $tr.find('td').each(function each() {
            var $td = $(this);
            var column = $td.data().column;
            if (!column) {
                return;
            }
            if (column === 'amount') {
                $(this).css(amountCssProps);
            }
            else if (column !== 'ponumber') {
                $(this).css(cssProps);
            }
        });
    }
    function getSeleectedItemsAmount(watch, elem, compute) {
        var _a, e_5, _b;
        var reference = compute.reference, url = compute.url, disableInput = compute.disableInput;
        var value = elem.val();
        var getCellName = reference;
        if (Array.isArray(reference)) {
            _a = __read(reference, 1), getCellName = _a[0];
        }
        if (value !== 0 && !value) {
            var _c = $.ezdia.config.pageParams, formType = _c.formType, account = _c.account;
            var total_1 = 0;
            var selectAllIsChecked = $('#selectAll').is(':checked');
            if (selectAllIsChecked) {
                var searchString = $('#searchFrm').search('getQueryString');
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: {
                        formtype: formType,
                        searchCondition: searchString,
                        accountName: account
                    },
                    dataType: 'json',
                    async: false,
                    success: function (res) {
                        var success = res.success, fieldDetails = res.fieldDetails;
                        if (success) {
                            total_1 = fieldDetails.outcome;
                        }
                    },
                    error: function () {
                        total_1 = 0;
                    }
                });
            }
            else {
                var grid = $('#grid');
                var ids = ezdia.util.getSelectedGridItemsByGridId();
                try {
                    for (var ids_1 = __values(ids), ids_1_1 = ids_1.next(); !ids_1_1.done; ids_1_1 = ids_1.next()) {
                        var id = ids_1_1.value;
                        total_1 += +grid.jqGrid('getCell', id, getCellName);
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (ids_1_1 && !ids_1_1.done && (_b = ids_1.return)) _b.call(ids_1);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
            elem.val(total_1);
        }
        if (disableInput) {
            elem.attr('readonly', 'readonly');
        }
        elem.trigger('change');
    }
    function getSeleectedGridItems(watch, elem, compute) {
        var disableInput = compute.disableInput;
        var value = elem.val();
        if (value !== 0 && !value) {
            var ids = ezdia.util.getSelectedGridItemsByGridId();
            elem.val(ids.length);
        }
        if (disableInput) {
            elem.attr('readonly', 'readonly');
        }
        elem.trigger('change');
    }
    function updateFirstRowOnLoad(watch, elem, compute) {
        setTimeout(function () {
            var e_6, _a;
            var name = elem.attr('name');
            var $table = $("#ez-js-group-field-table-" + name);
            var conditions = compute.conditions;
            try {
                for (var watch_1 = __values(watch), watch_1_1 = watch_1.next(); !watch_1_1.done; watch_1_1 = watch_1.next()) {
                    var input = watch_1_1.value;
                    var fieldName = input.name, value = input.value;
                    $table
                        .find("[name$=\"" + name + "_" + conditions[fieldName] + "0\"]")
                        .val(value)
                        .trigger('change');
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (watch_1_1 && !watch_1_1.done && (_a = watch_1.return)) _a.call(watch_1);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }, 0);
    }
    function paypalIdRenderOnload(watch, elem) {
        var paypalIdCheckBoxMarkup = TEMPLATES.paypalIdCheckBoxMarkup;
        var id = ezdia.util.makeId();
        var HTMLContent = paypalIdCheckBoxMarkup(id);
        elem.after(HTMLContent);
        $("#" + id).on('click', function click() {
            setPaypalIdAsEmail.call(this, watch, elem);
        });
    }
    function setPaypalIdAsEmail(watch, elem) {
        var type = 'ez.paypalidchange';
        if (this.checked) {
            var emailvalue = watch.val() || '';
            elem.val(emailvalue).attr('readonly', 'readonly');
            watch.on("change." + type, function change() {
                elem.val(this.value);
            });
        }
        else {
            elem.removeAttr('readonly');
            watch.off("change." + type);
        }
    }
    /**
     * This method compute final price
     * first field name in reference used as base value.
     * second field in reference used as Discount value in percentage.
     * third field in reference used as noOfItems value.
     * only one base and percentage and noOfItemsfield considered in this method.
     */
    function computeFinalPrice(watch, elem, compute) {
        var e_7, _a;
        var reference = compute.reference;
        var _b = __read(reference, 3), basePriceName = _b[0], discountName = _b[1], noOfItemsName = _b[2];
        var basePrice = 0;
        var discount = 0;
        var noOfItems = 1;
        var finalprice = 0;
        var hasValue = false;
        try {
            for (var watch_2 = __values(watch), watch_2_1 = watch_2.next(); !watch_2_1.done; watch_2_1 = watch_2.next()) {
                var curElem = watch_2_1.value;
                var name_2 = curElem.name, value = curElem.value;
                if (!value && value !== 0) {
                    continue;
                }
                hasValue = true;
                if (name_2 === basePriceName) {
                    basePrice = value || 0;
                }
                else if (name_2 === discountName) {
                    discount = value || 0;
                }
                else if (name_2 === noOfItemsName) {
                    noOfItems = value || 1;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (watch_2_1 && !watch_2_1.done && (_a = watch_2.return)) _a.call(watch_2);
            }
            finally { if (e_7) throw e_7.error; }
        }
        if (!hasValue) {
            elem.val('').trigger('change', true);
            return;
        }
        if (discount) {
            finalprice = basePrice - (basePrice * discount) / 100;
        }
        else {
            finalprice = basePrice;
        }
        finalprice *= noOfItems;
        finalprice = +finalprice.toFixed(2);
        elem.val(finalprice);
        elem.trigger('change', true);
    }
    function update(watch, elem) {
        setTimeout(function () {
            var value = '';
            $.each(watch, function eachwatch() {
                value = this.value;
            });
            elem.val(value);
        }, 0);
    }
    function addition(watch, elem) {
        var value = 0;
        $.each(watch, function eachwatch() {
            value += +this.value;
        });
        elem.val(value);
    }
    function handelProjectTypeForSOWChange(watch, elem, compute, template, column) {
        var type = 'ez.compute';
        watch.off(type).on("change." + type, function () {
            updateProjectTypeForSOW(watch, column);
        });
    }
    function updateProjectTypeForSOW(watch, columnProps) {
        var column = columnProps;
        var value = '';
        var userInput = true;
        $.each(watch, function eachwatch() {
            value = this.value;
        });
        if (value) {
            userInput = false;
        }
        column.config.userInput = userInput;
    }
    var computeObject = {
        fn: {
            rules: rules,
            templates: computeTemplates,
            updatePaypalId: updatePaypalId,
            multiplication: multiplication,
            hide: hide,
            show: show,
            hideColumn: hideColumn,
            showColumn: showColumn,
            createAnswers: createAnswers,
            sowName: sowName,
            updatePoNumberRow: updatePoNumberRow,
            computeFinalPrice: computeFinalPrice,
            update: update,
            addition: addition
        },
        runOnRender: {
            hide: hide,
            show: show,
            hideColumn: hideColumn,
            showColumn: showColumn,
            createAnswers: createAnswersOnRun,
            updatePoNumberRow: updatePoNumberRow,
            getSeleectedItemsAmount: getSeleectedItemsAmount,
            getSeleectedGridItems: getSeleectedGridItems,
            updateFirstRowOnLoad: updateFirstRowOnLoad,
            paypalIdRenderOnload: paypalIdRenderOnload,
            computeFinalPrice: computeFinalPrice,
            update: update,
            addition: addition,
            handelProjectTypeForSOWChange: handelProjectTypeForSOWChange
        },
        init: function (initObj, obj) {
            var column = obj.column;
            // eslint-disable-next-line no-param-reassign
            initObj[column.id || column.name] = obj;
        },
        create: function (key, obj) {
            var self = this;
            var col = obj.column;
            var computeConfigs = col.config.compute;
            if (computeConfigs.constructor === Array) {
                $.each(computeConfigs, function each(i, computeConfig) {
                    self.compute(key, computeConfig, col);
                });
            }
            else {
                self.compute(key, computeConfigs, col);
            }
        },
        createAll: function (initObj) {
            var _this = this;
            $.each(initObj, function (key, obj) {
                _this.create(key, obj);
            });
        },
        compute: function (key, computes, column) {
            var self = this;
            var reference = computes.reference;
            var elem = $("#" + key);
            var type = 'ez.compute';
            var event = computes.event || 'keyup';
            var callbackFnName = 'rules';
            var callback = null;
            var watch = null;
            var template = null;
            if (typeof reference !== 'string') {
                reference = reference.join('], [name=');
            }
            watch = $("[name=" + reference + "]");
            if (!reference.length && !elem.length) {
                return;
            }
            if (computes.fn) {
                callbackFnName = computes.fn;
            }
            else if (computes.template) {
                callbackFnName = 'templates';
                template = $.ezdia.template.get(computes.template, '', true);
                event = 'change';
            }
            if (computes.renderOnly) {
                callback = self.runOnRender[callbackFnName] || self.fn[callbackFnName];
                if (callback) {
                    callback(watch, elem, computes, template);
                }
                return;
            }
            callback = self.fn[callbackFnName];
            watch.off(type).on(event + "." + type, function () {
                callback(watch, elem, computes, template, column);
            });
            if (callbackFnName !== 'createAnswers' &&
                callbackFnName !== 'hide' &&
                callbackFnName !== 'show') {
                elem.off("change." + type).on("change." + type, function (e, origin) {
                    if (!origin) {
                        watch.off("change." + type);
                        elem.off("change." + type);
                    }
                });
            }
            if (computes.fn && self.runOnRender[computes.fn]) {
                self.runOnRender[computes.fn](watch, elem, computes, template, column);
            }
        }
    };
    var widgets;
    (function (widgets) {
        widgets.compute = computeObject;
    })(widgets = ezdia.widgets || (ezdia.widgets = {}));
    /**
     * This line of code for support old code.
     * It should be removed in future
     */
    $.ezdia.compute = computeObject;
})(ezdia || (ezdia = {}));
